module.exports = __webpack_public_path__ + "img/OBCINA PESNICA.0f53ecdc.png";